import { t } from 'i18next';
import React, { useRef, useState, useEffect } from 'react';
import { format } from 'react-string-format';


import "./../ThankyouPage.scss";

export function BillingDetails(props) { 

    // Link continuous (10022) / Link one off (10023) are Stripe "Link" mandate types that have no real
    // card details (the card number comes back as a placeholder like ...0000). Detect them so we show the
    // Link logo + "Payment done with Link" instead of a broken card logo and a fake "card ending 0000".
    const cardTypeStr = props?.cardType != null ? props.cardType.toString().toLowerCase() : "";
    const isLinkPayment =
        cardTypeStr === 'link' ||
        cardTypeStr === '10022' ||
        cardTypeStr === '10023' ||
        cardTypeStr === 'link continuous' ||
        cardTypeStr === 'link one off';

    return (
        <div className="details-block">
            <div className="item-container">
                <div className="item-wrapper">
                    <h4>{t("thankyoupage.billingtitle") }</h4>
                </div>

                {props?.billingAddress &&
                    <>
                        {props.billingAddress?.locationId !== 0 &&
                          
                                <div className="item-wrapper">
                                    <div className="item-field">
                                         <p><strong>{t("thankyoupage.billingaddress")}</strong></p>
                                         <p> {props.billingAddress?.companyName && props?.billingAddress.companyName + ', '}
                                             {props.billingAddress?.address1 && props?.billingAddress.address1 + ', '}
                                            {props?.billingAddress?.address2 && props?.billingAddress.address2 + ', '}
                                            {props?.billingAddress?.address3 && props?.billingAddress.address3 + ', '}
                                            {props?.billingAddress?.town && props?.billingAddress.town + ', '}
                                            {props?.billingAddress?.county && props?.billingAddress.county + ', '}
                                            {props?.billingAddress?.country && props?.billingAddress.country + ', '}
                                            {props?.billingAddress?.postcode}
                                        </p>
                         
                            

                                    </div>
                                </div>
                          }
                    </>
                }
                <div className="item-wrapper">
                    <div className="item-field">
                        <p><strong>{t("thankyoupage.billingpaymenttitle")}</strong></p>
                    </div>
              
                    <div className="payment-method ">
                            <img
                                src={`/assets/paymenttypes/logos/${props.paymentType === 3 ? 'directdebit' :
                                    props.paymentType === 10010 ? 'paypal' :
                                    props.paymentType === 20 ? 'invoice' :
                                    props.paymentType === 10008 ? 'invoice' :
                                    isLinkPayment ? 'link' :
                                    (props.paymentType === 7 || props.paymentType === 2) ? props?.cardType :
                                     props.paymentType === undefined && 'invoice'
                                }.svg`}
                                alt="logo"
                            />
                        {props.paymentType === 3 && <p>{t("thankyoupage.billingpaymentwith")} Direct Debit  </p>}
                        {(props.paymentType === 7 || props.paymentType === 2) && !isLinkPayment && (
                            <p> {t("thankyoupage.billingpaymentcard")}<strong> {props?.cardNumber} </strong></p>
                        )}
                        {isLinkPayment && (
                            <p>{t("thankyoupage.billingpaymentwith")} Link</p>
                        )}
                        {props.paymentType === 10010 && <p>{t("thankyoupage.billingpaymentwith")} Paypal</p>}
                        {(props.paymentType === 10008 || props.paymentType === 20) && <p>{t("thankyoupage.billingpaymentwithinvoice")}</p>}
                    </div>
                    {props.paymentType === 3 && <div className="item-container">
                        <div className="border-seperator"> </div>
                        <div className="item-wrapper">  
                            <div><strong>{t("thankyoupage.billingaccountholder")}:</strong> {props.directDebit.accountholder} </div>
                            <div> <strong>{t("thankyoupage.billingBank")}:</strong> {props.directDebit.bankname}</div>
                            <div> <strong>{t("thankyoupage.billingaccountnumber")}:</strong>  {props.directDebit.accountnumber} </div>
                            <div> <strong>{t("thankyoupage.billingsortcode")}:</strong>  {props.directDebit.sortcode} </div>
                        </div>
                     <div className="border-seperator hide-element"> </div>
                      </div>}

                </div>
                {(props?.nextPayment && props.paymentType!==3) &&
                    <> 
                    <div className="item-field three-columns">
                        <div className="one-column"><p><strong>{t("thankyoupage.nextcollectiondate")}</strong> </p><p>{props?.nextPayment?.nextpaymentdate}</p></div>
                        <div className="one-column right"><p><strong>{t("thankyoupage.nextpayment")}</strong></p><p>{props?.currency}{props?.nextPayment?.amount?.toFixed(2)}</p></div>
                    </div>
                </>
                }
            </div>
        </div>
    )
}